import { render } from "./AutoPassTable.vue?vue&type=template&id=c8f6eee4"
import script from "./AutoPassTable.vue?vue&type=script&lang=js"
export * from "./AutoPassTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__